import { SignalBusinessHours } from '@provision/entity-types';
import { Dayjs } from 'dayjs';

export type SignalBusinessHoursQueryResponse = Omit<
  SignalBusinessHours,
  'partner' | 'updatedAt'
>;

export type SignalBusinessHoursMutationInput = Omit<
  SignalBusinessHours,
  'partner' | 'updatedAt' | 'createdAt' | 'id' | 'signalBusinessHoursId'
>;

export interface SignalBusinessHoursEntity
  extends Omit<
    SignalBusinessHoursQueryResponse,
    'timeFrom' | 'timeTo' | 'urgency' | 'weekDay'
  > {
  timeFrom: string;
  timeTo: string;
  urgency: SignalUrgencyLevel;
  weekDay: WeekDay;
  createdAt: string;
}

// SignalUrgencyLevel enum should be in sync with `signal_urgency_level` enum in Postgres.
export enum SignalUrgencyLevel {
  Normal = 'normal',
  Urgent = 'urgent',
  LifeSafety = 'life-safety',
  SignatureUrgent = 'signature-urgent', // to be deprecated.
}

export enum WeekDay {
  Sunday = 0,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export type DefaultSignalBusinessHoursResponse = {
  urgency: string;
  signalBusinessHours: {
    weekday: number;
    startHour: number;
    startMinute: number;
    endHour: number;
    endMinute: number;
  }[];
};

export type DefaultSignalBusinessHour = {
  urgency: SignalUrgencyLevel;
  signalBusinessHours: {
    from: Dayjs;
    to: Dayjs;
    weekday: WeekDay;
  }[];
};

export type SignalBusinessHourInput = Omit<
  SignalBusinessHoursEntity,
  'id' | 'signalBusinessHoursId' | 'partnerId' | 'createdAt'
>;
